import { render, staticRenderFns } from "./Orden.vue?vue&type=template&id=76b70d9e&"
import script from "./Orden.vue?vue&type=script&lang=js&"
export * from "./Orden.vue?vue&type=script&lang=js&"
import style0 from "./Orden.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports